import { IconTrendingUp } from "@tabler/icons-react";
import FelixCard from "../../../util/ui/felixCard";
import { CardContent, CardHeader } from "@mui/material";
import Patrimonio from "../../../../models/analises/patrimonio";
import TabelaPerformance from "../../../util/tabelas/tabelaPerformance";
import ChartContainer from "../../../util/charts/chartContainer";

type Props = {
  patrimonio?: Patrimonio[];
};

export default function Performance({ patrimonio }: Props) {
  return (
    <FelixCard>
      <CardHeader title={"Performance"} avatar={<IconTrendingUp size={16} />} />
      <CardContent>
        <ChartContainer
          emptyText="Ainda não há resultados mensais."
          isEmpty={patrimonio?.length === 0}
          isLoading={!!!patrimonio}
        >
          <TabelaPerformance patrimonio={patrimonio} />
        </ChartContainer>
      </CardContent>
    </FelixCard>
  );
}
